<template>
  <b-card>
    <LevelsFormModal
      :level="toBeEditedLevel"
      @refetch="fetchList"
    />
    <b-row>
      <b-col md="4">
        <ZonesSearch
          label="Search levels by zone"
          :clearable="false"
          @zone-selected="setSelectedZone"
        />
      </b-col>
      <b-col
        md="8"
        class="d-flex justify-content-end align-items-center"
      >
        <b-button
          class="mb-1"
          variant="primary"
          @click="createLevelHandler"
        >
          Create New Team Level
        </b-button>
      </b-col>
    </b-row>
    <BaseOverlay
      :show="loading"
    >
      <b-table
        :fields="tableColumns"
        :items="list"
        striped
        hover
        responsive
        show-empty
        empty-text="No matching records found"
      >
        <template #cell(actions)="data">
          <div class="d-flex align-items-center">
            <b-button
              v-if="$can('write', 'teams')"
              variant="flat-primary"
              @click="editLevelHandler(data.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              variant="flat-primary"
              @click="$router.push(`/teams/levels/view-details/${data.item.id}`)"
            >
              <feather-icon icon="EyeIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
    </BaseOverlay>
  </b-card>
</template>

<script>
import {
  BCard,
  BTable,
  BButton,
  BRow,
  BCol,
} from 'bootstrap-vue'
import {
  ref,
} from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import LevelsFormModal from '../components/LevelsFormModal.vue'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import ZonesSearch from '@/views/zones/components/ZonesSearch.vue'

export default {
  components: {
    BCard,
    BTable,
    BButton,
    LevelsFormModal,
    BaseOverlay,
    ZonesSearch,
    BRow,
    BCol,
  },
  setup(_, ctx) {
    const tableColumns = [
      {
        label: 'Name English',
        key: 'nameEn',
        formatter: (_1, _2, item) => item.name.en,
      },
      {
        label: 'Name Arabic',
        key: 'nameAr',
        formatter: (_1, _2, item) => item.name.ar,
      },
      {
        label: 'Description English',
        key: 'descEn',
        formatter: (_1, _2, item) => item.description.en,
      },
      {
        label: 'Description Arabic',
        key: 'descAr',
        formatter: (_1, _2, item) => item.description.ar,
      },
      {
        label: 'sort',
        key: 'sort',
      },
      // {
      //   label: 'Members',
      //   key: 'configuration',
      //   formatter: (_1, _2, item) => item.configuration.numberOfMembers,
      // },
      'actions',
    ]
    const list = ref([])
    const loading = ref(false)
    const queryParams = ref({
      zone: null,
    })

    const fetchList = async () => {
      loading.value = true

      const result = await axiosIns.get('/teams/levels', {
        params: queryParams.value,
      })
      list.value = result.data.data
      loading.value = false
    }

    const setSelectedZone = ev => {
      queryParams.value.zone = ev
      fetchList()
    }

    const toBeEditedLevel = ref()

    const createLevelHandler = () => {
      toBeEditedLevel.value = undefined
      ctx.root.$bvModal.show('create-team-level-modal')
    }

    const editLevelHandler = level => {
      toBeEditedLevel.value = level
      ctx.root.$bvModal.show('create-team-level-modal')
    }

    return {
      loading,
      queryParams,
      tableColumns,
      list,
      fetchList,
      setSelectedZone,
      createLevelHandler,
      toBeEditedLevel,
      editLevelHandler,
    }
  },
}
</script>

  <style></style>
